module.exports = __webpack_public_path__ + "media/images/icon__email@2x-601fa5ae203052e154308fa3f52b9f24.png";